import { render, staticRenderFns } from "./OfferView.vue?vue&type=template&id=2a833e98&scoped=true&"
import script from "./OfferView.vue?vue&type=script&lang=js&"
export * from "./OfferView.vue?vue&type=script&lang=js&"
import style0 from "./OfferView.vue?vue&type=style&index=0&id=2a833e98&prod&lang=scss&scoped=true&"
import style1 from "./OfferView.vue?vue&type=style&index=1&id=2a833e98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a833e98",
  null
  
)

export default component.exports